import { render, staticRenderFns } from "./Tbi.vue?vue&type=template&id=3cdf62b9&"
import script from "./Tbi.vue?vue&type=script&lang=js&"
export * from "./Tbi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports